import { useState, useEffect, useRef, useCallback } from 'react'

interface ApiEndpoint {
  url: string
  key: string
}
interface MapData {
  events: ApiEndpoint
  mapData: ApiEndpoint
}

export const useMapData = (endpoints: MapData) => {
  const [data, setData] = useState<any[]>([])
  const [error, setError] = useState<Error | null>(null)
  const [loading, setLoading] = useState(true)
  const controller = useRef(new AbortController())
  const getData = useCallback(async () => {
    try {
      const mapData = await fetch(endpoints.mapData.url, {
        signal: controller.current.signal,
        headers: {
          Authorization: `Bearer ${endpoints.mapData.key}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': endpoints.mapData.key
        }
      })
        .then((d) => d.json())
        .catch((err) => {
          setError(err)
          setLoading(false)
        })
      const events = await fetch(endpoints.events.url, {
        signal: controller.current.signal,
        headers: {
          Authorization: `Bearer ${endpoints.events.key}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': endpoints.events.key
        }
      })
        .then((d) => d.json())
        .catch((err) => {
          setError(err)
          setLoading(false)
        })

      const mappedEvents = events?.features?.reduce(
        (majorEvents, curr) => {
          if (curr?.properties?.type === 'Major Project') {
            curr.properties.status = 'Major'
            return [...majorEvents, curr]
          } else {
            return majorEvents
          }
        },
        [endpoints]
      )

      setData([...mappedEvents, ...(mapData?.features ?? [])])
      setLoading(false)
    } catch (err) {
      setError(err as Error)
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    if (error) {
      console.log(`fetchMapDataError: ${error?.message}`)
    }
  }, [error])

  return { data, error, loading }
}
